<template>
  <div id="privacy-policy-page">
    <div class="background-header d-flex justify-center">
      <v-img
        src="/img/pdpa/logo-pdpa.webp"
        width="250"
        height="250"
        contain
        class="logo"
      />
    </div>

    <div class="container">
      <div class="text-center">
        <h1>
          นโยบายความเป็นส่วนตัว และ
          คุ้มครองข้อมูลส่วนบุคคล
        </h1>
      </div>

      <!-- กลุ่มบริษัท เซลสุกิ จำกัด (“บริษัท”) -->
      <div>
        กลุ่มบริษัท เซลสุกิ จำกัด (“บริษัท”) ขอแนะนำให้ท่านทำความเข้าใจนโยบาย
        ส่วนบุคคล (PRIVACY POLICY) นี้ เนื่องจาก นโยบายนี้อธิบายถึงวิธีการที่
        บริษัทปฏิบัติต่อข้อมูลส่วนบุคคลของท่าน เช่น การเก็บรวบรวม การจัดเก็บ
        รักษา การใช้ การเปิดเผย รวมถึงสิทธิต่างๆ ของท่าน เป็นต้น เพื่อให้ท่านได้
        รับทราบถึงนโยบายในการคุ้มครองข้อมูลส่วนบุคคลของบริษัท บริษัท ตระหนัก
        ถึงความสำคัญของการปกป้องข้อมูลส่วนบุคคลของลูกค้า พนักงาน รวม
        ตลอดถึงคู่ค้าของบริษัท ด้วยเหตุนี้บริษัทจึงได้จัดให้มีมาตรการในการเก็บรักษา
        และป้องกันตามมาตราฐานของกฎหมาย ข้อกำหนด และระเบียบเกี่ยวกับการ
        คุ้มครองข้อมูลส่วนบุคคล อย่างเคร่งครัด ดังต่อไปนี้
      </div>

      <!-- 1. คำนิยาม -->
      <div>
        <p class="font-weight-bold">
          1. คำนิยาม
        </p>
        <p>
          <span class="font-weight-bold">
            “กลุ่มบริษัท เซลสุกิ จำกัด (“บริษัท”)”
          </span>
          หมายความว่า กลุ่มบริษัทที่ประกอบ
          ด้วย 3 บริษัทดังต่อไปนี้ บริษัทเซลสุกิ จำกัด (ประกอบด้วยบริการ Beary
          Web & Tech Service, LINE Agency, Fuse Advertising, Kaikong
          Content Marketing, Shipmunk : Delivery Booking) บริษัท อคิตะ
          ฟูลฟิลเมนท์ จำกัด (Akita Fulfillment) และบริษัท มิลเลเนี่ยมฟอลคอน
          จำกัด (Oc2Plus : Customer Data Platform)
        </p>
        <p>
          <span class="font-weight-bold">
            “ข้อมูลส่วนบุคคล”
          </span>
          หมายความว่า ข้อมูลเกี่ยวกับบุคคลซึ่งทำให้สามารถระบุ
          ตัวบุคคลนั้นได้ไม่ว่าทางตรงหรือทางอ้อม แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่
          กรรมโดยเฉพาะ
        </p>
        <p>
          <span class="font-weight-bold">
            “ผู้ควบคุมข้อมูลส่วนบุคคล”
          </span>
          หมายความว่า บุคคลหรือนิติบุคคลซึ่งทำให้มี
          อำนาจหน้าที่ตัดสินใจเกี่ยวกับการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล
        </p>
        <p>
          <span class="font-weight-bold">
            “ผู้ประมวลผลข้อมูลส่วนบุคคล”
          </span>
          หมายความว่า บุคคลหรือนิติบุคคลซึ่งดำเนิน
          การเกี่ยวกับรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลตามคำสั่งหรือในนาม
          ของผู้ควบคุมข้อมูลส่วนบุคคล ทั้งนี้ บุคคลหรือนิติบุคคลซึ่งดำเนินการดัง
          กล่าวไม่เป็นผู้ควบคุมข้อมูลส่วนบุคคล
          “เจ้าของข้อมูล” หมายความว่า ลูกค้า พนักงาน คู่ค้า ซึ่งเป็นบุคคลธรรมดา
          “บุคคล” หมายความว่า บุคคลธรรมดา
        </p>
      </div>

      <!-- 2. วัตถุประสงค์ในการจัดทำนโยบายการคุ้มครองข้อมูลส่วนบุคคล -->
      <div>
        <p class="font-weight-bold">
          2. วัตถุประสงค์ในการจัดทำนโยบายการคุ้มครองข้อมูลส่วนบุคคล
        </p>
        <p>
          บริษัทจัดทำนโยบายการคุ้มครองข้อมูลส่วนบุคคลเพื่อคุ้มครองข้อมูลของลูกค้า
          พนักงาน รวมตลอดถึง คู่ค้าของบริษัท ในการทำธุรกรรมต่าง ๆ กับบริษัท ให้มี
          ความปลอดภัยน่าเชื่อถือ และเพื่อให้เจ้าของข้อมูลได้รับการคุ้มครองอย่างมี
          ประสิทธิภาพและได้รับการป้องการการนำข้อมูลส่วนบุคคลของเจ้าของข้อมูล
          ไปใช้โดยไม่ได้รับอนุญาต อีกทั้งเพื่อให้มีการเยียวยาเจ้าของข้อมูลส่วนบุคค
          ตามกฎหมายที่เกี่ยวข้อง
        </p>
      </div>

      <!-- 3. การเก็บข้อมูลส่วนบุคคลอย่างจำกัด -->
      <div>
        <p class="font-weight-bold">
          3. การเก็บข้อมูลส่วนบุคคลอย่างจำกัด
        </p>
        <p>
          การจัดเก็บรวบรวมข้อมูลส่วนบุคคลจะกระทำโดยมี วัตถุประสงค์ ขอบเขต และ
          ใช้วิธีการที่ชอบด้วยกฎหมายและเป็นธรรม ในการเก็บรวบรวมและจัดเก็บข้อมูล
          ตลอดจนเก็บรวบรวม และจัดเก็บข้อมูลส่วนบุคคลอย่างจำกัดเพียงเท่าที่จำเป็น
          แก่การให้บริการ หรือบริการด้วยวิธีการทางอิเล็กทรอนิกส์อื่นใดภายใต้วัตถุ
          ประสงค์ของบริษัทเท่านั้น ทั้งนี้ บริษัทจะดำเนินการให้เจ้าของข้อมูล รับรู้ ให้
          ความยินยอม ทางอิเล็กทรอนิกส์ ตามแบบวิธีการของบริษัท
        </p>

        <div class="my-10">
          <p>บริษัท ได้เก็บรวบรวมข้อมูลของท่านผ่าน 2 ช่องทาง ได้แก่ </p>
          <p>1.ข้อมูลที่ท่านแสดงและส่งมอบให้กับบริษัท</p>
          <p>2.ข้อมูลที่เราเก็บรวบรวมผ่านบริการของ Third-Party</p>
        </div>

        <p>
          บริษัทอาจจัดเก็บข้อมูลส่วนบุคคลของท่านซึ่งเกี่ยวกับความสนใจและบริการที่
          ท่านใช้ ซึ่งอาจประกอบด้วยเรื่อง เชื้อชาติ ศาสนาหรือปรัชญา ข้อมูลสุขภาพ
          ของท่าน ข้อมูลชีวภาพ ทุพพลภาพ ความพิการ อัตลักษณ์ หรือข้อมูลอื่นใด
          ที่จะเป็นประโยชน์ในการให้บริการ ทั้งนี้ การดำเนินการดังกล่าวข้างต้น บริษัทจะ
          ขอความยินยอมจากท่านก่อนทำการเก็บรวบรวม เว้นแต่
        </p>
        <p>
          3.1. เป็นการปฏิบัติตามกฎหมาย เช่น พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
          พระราชบัญญัติว่าด้วยธุรกรรมทางอิเล็กทรอนิกส์ พระราชบัญญัติการประกอบ
          กิจการโทรคมนาคม พระราชบัญญัติป้องกันและปราบปรามการฟอกเงิน ประมวล
          กฎหมายแพ่งและอาญา ประมวลกฎหมายวิธีพิจารณาความแพ่งและอาญา เป็นต้น
        </p>
        <p>
          3.2. เป็นไปเพื่อประโยชน์แก่การสอบสวนของพนักงานสอบสวน หรือการ
          พิจารณาพิพากษาคดีของศาล
        </p>
        <p>
          3.3. เพื่อประโยชน์ของท่าน และการขอความยินยอมไม่อาจกระทำได้ในเวลานั้น
        </p>
        <p>
          3.4. เป็นการจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมายของบริษัท หรือของ
          บุคคลหรือนิติบุคคลอื่นที่ไม่ใช่บริษัท
        </p>
        <p>
          3.5. เป็นการจำเป็นเพื่อป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพ
          ของบุคคล
        </p>
        <p>
          3.6. เป็นการจำเป็นเพื่อการปฏิบัติตามสัญญาซึ่งเจ้าของข้อมูลส่วนบุคคลเป็น
          คู่สัญญาหรือเพื่อใช้ในการดำเนินการตามคำขอของเจ้าของข้อมูลส่วนบุคคล
          ก่อนเข้าทำสัญญานั้น
        </p>
        <p>
          3.7. เพื่อให้บรรลุวัตถุประสงค์ที่เกี่ยวกับการจัดทำเอกสารประวัติศาสตร์หรือ
          จดหมายเหตุ เพื่อประโยชน์สาธารณะ หรือเพื่อการศึกษา วิจัย การจัดทำสถิติ
          ซึ่งได้จัดให้มีมาตรการป้องกันที่เหมาะสม
        </p>
        <p>
          3.8 ข้อมูลพฤติกรรมการใช้งาน ผ่านเครื่องมือดังต่อไปนี้ Google Analytics,
          Google AdWords, Hotjar และ Facebook Pixel เพื่อวิเคราะห์ความ
          สามารถของ platform รวมถึงวางแผนการพัฒนา platform ในอนาคต
          โดยเป็นข้อมูลการใช้งานและไม่เกี่ยวข้องกับข้อมูลส่วนบุคคลใดๆทั้งสิ้น
        </p>
      </div>

      <!-- 4. วัตถุประสงค์ในการเก็บรวบรวมข้อมูลส่วนบุคคล -->
      <div>
        <p class="font-weight-bold">
          4. วัตถุประสงค์ในการเก็บรวบรวมข้อมูลส่วนบุคคล
        </p>
        <p>
          บริษัทจะดำเนินการจัดเก็บรวบรวม ใช้ ปรับปรุงและเปิดเผยข้อมูลส่วนบุคคล
          ของผู้ให้ข้อมูลตามวัตถุประสงค์ ขอบเขต และตามวิธีการที่กฎหมายหมาย
          กำหนด โดยจะจัดเก็บเพียงเท่าที่จำเป็นแก่การให้บริการ และการดำเนินงาน
          ของบริษัทเพื่อประโยชน์ของเจ้าของข้อมูลเป็นหลัก และการอื่น ๆตามกฎหมาย
          เพื่อวัตถุประสงค์ ดังนี้
        </p>
        <p>
          4.1) เพื่อใช้ในการประมวลผล บริหารจัดการ พิจารณา ให้บริการและการดำเนิน
          งานต่าง ๆ ซึ่งเกี่ยวกับธุรกิจของบริษัทที่มีอยู่ในปัจจุบัน และอาจมีขึ้นในอนาคต
          และรวมถึงการใด ๆ เพื่อประโยชน์ของเจ้าของข้อมูล ตลอดจนนำไปใช้ในการ
          จัดทำบัญชี งบการเงิน และข้อมูลทางบัญชีของบริษัท
        </p>
        <p>
          4.2) เพื่อใช้ในการติดตามและเรียกเก็บหนี้สินอื่นใด (ถ้ามี) จากเจ้าของข้อมูล
          ซึ่งบริษัทมีสิทธิตามกฎหมาย
        </p>
        <p>
          4.3) เพื่อใช้ในการแก้ไข ยกเลิก และ/หรือต่ออายุสัญญาเช่าซื้อ สัญญาจ้าง
          และสัญญาอื่นใดระหว่างเจ้าของข้อมูลกับบริษัท
        </p>
        <p>
          4.4) เพื่อใช้เป็นข้อมูลในการวิเคราะห์ เสนอ ให้ใช้ เพื่อการวิจัยการตลาดและ/
          หรือการจัดกิจกรรมส่งเสริมการขาย และ/หรือเพื่อประโยชน์ในการจัดทำฐาน
          ข้อมูลและใช้ข้อมูลเพื่อเสนอสิทธิประโยชน์ตามความสนใจของ เจ้าของข้อมูล
          และ/หรือปรับปรุงการให้บริการ การดำเนินการ หรือผลิตภัณฑ์ของบริษัท
        </p>
        <p>
          4.5) เพื่อปฏิบัติตามระเบียบ ประกาศ ข้อบังคับ รวมตลอดถึงข้อกำหนดอื่นใด
          ซึ่งบริษัทมีหน้าที่ผูกพันในการปฏิบัติตามกฎหมาย
        </p>
        <p>
          4.6) เพื่อการนำเสนอข้อมูล ติดตาม ประสานงาน และการให้บริการหลังการ
          ขายรวมตลอดถึงเพื่อการจัดทำบริการทางอิเล็คทรอนิกส์
        </p>
        <p>
          4.7) เพื่อดำเนินการอื่นใดที่เกี่ยวข้องเพื่อให้บรรลุวัตถุประสงค์ดังที่ได้กล่าว
          มาข้างต้น
        </p>
      </div>

      <!-- 5. ข้อจำกัดในการใช้ข้อมูลส่วนบุคคล -->
      <div>
        <p class="font-weight-bold">
          5. ข้อจำกัดในการใช้ข้อมูลส่วนบุคคล
        </p>
        <p>
          บริษัทจะทำการเก็บข้อมูลส่วนบุคคลตามมาตรฐานที่กฎหมายกำหนดและจะ
          ไม่ทำการใช้หรือเปิด เผยข้อมูลดังกล่าวต่อบุคคลภายนอกโดยไม่ได้รับ
          ความยินยอมของเจ้าของข้อมูล เว้นแต่เพื่อปฏิบัติตามวัตถุประสงค์ที่ระบุ
          ไว้ข้างต้น หรือตามที่กฎหมายกำหนดให้ต้องทำการเปิดเผย โดยจะเปิดเผย
          ข้อมูลส่วนบุคคลให้กับหน่วยงานหรือบุคคลที่เกี่ยวข้องดังนี้
        </p>
        <p>
          5.1) กลุ่มธุรกิจ พันธมิตรทางธุรกิจ ของบริษัท รวมตลอดถึงหน่วยงานของ
          รัฐที่เกี่ยวข้อง ในการให้บริการในการประมวลผล บริหารจัดการ พิจารณา ให้
          บริการและการดำเนินงานต่าง ๆ ที่เจ้าของข้อมูลได้รับและอาจได้รับในอนาคต
        </p>
        <p>
          5.2) บริษัท รวมตลอดถึงบริษัทในเครือกิจการหรือเครือธุรกิจเดียวกัน หรือ
          หน่วยงานอื่นที่เกี่ยวข้อง
        </p>
        <p>
          5.3)พนักงาน ผู้รับมอบอำนาจ ตัวแทน บุคคลหรือนิติบุคคลผู้ให้บริการด้าน
          การเร่งรัดหนี้สิน และ/หรือผู้ตรวจสอบบัญชีของบริษัท และ/หรือบริการและ
          การดำเนินงานต่าง ๆ ซึ่งเกี่ยวกับธุรกิจของบริษัทที่มีอยู่ในปัจจุบันและอาจ
          มีขึ้นในอนาคต
        </p>
        <p>
          5.4) พนักงาน ผู้รับมอบอำนาจ ตัวแทน บุคคล นิติบุคคลหรือหน่วยงานอื่นใด
          เพื่อปฏิบัติตามข้อกำหนดของกฎหมายหรือก่อตั้งสิทธิตามสัญญาของบริษัท
        </p>
      </div>

      <!-- 6. สิทธิของเจ้าของข้อมูลส่วนบุคคล -->
      <div>
        <p class="font-weight-bold">
          6. สิทธิของเจ้าของข้อมูลส่วนบุคคล
        </p>
        <p>
          บริษัทให้ความสำคัญกับสิทธิของเจ้าของข้อมูลส่วนบุคคล จึงได้กำหนดสิทธิ
          ของเจ้าของข้อมูลในการดำเนินการกับข้อมูลส่วนบุคคลของตนซึ่งบริษัทเก็บ
          รวบรวมไว้เพื่อให้สอดคล้องกับกฎหมาย ดังนี้
        </p>
        <p>
          6.1) ขอเข้าถึงและขอรับสำเนาข้อมูลส่วนบุคคลที่เกี่ยวกับตน ซึ่งอยู่ในความ
          รับผิดชอบของบริษัทได้ตามหลักเกณฑ์และวิธีการที่บริษัทกำหนด หรือขอให้
          เปิดเผยถึงการได้มาซึ่งข้อมูลส่วนบุคคลดังกล่าวที่ตนไม่ได้ให้ความยินยอม
        </p>
        <p>
          6.2) ขอรับข้อมูลส่วนบุคคลที่เกี่ยวกับตนจากบริษัทได้ ในกรณีที่บริษัทได้ทำ
          ให้ข้อมูลส่วนบุคคลนั้นอยู่ในรูปแบบที่สามารถอ่านหรือใช้งานโดยทั่วไปได้ด้วย
          เครื่องมือหรืออุปกรณ์ที่ทำงานได้โดยอัตโนมัติ และสามารถใช้หรือเปิดเผย
          ข้อมูลส่วนบุคคลได้ด้วยวิธีการอัตโนมัติ
        </p>
        <p>
          6.3) คัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลที่เกี่ยวกับตน
          ที่กฎหมายอนุญาตให้เก็บได้โดยไม่ต้องได้รับความยินยอมจากผู้ให้ข้อมูล
          เมื่อใดก็ได้
        </p>
        <p>
          6.4) ขอให้บริษัทลบหรือทำลาย หรือทำให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่
          สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูลส่วนบุคคลได้ ในกรณีตามที่กฎหมาย
          กำหนด
        </p>
        <p>
          6.5) ขอให้บริษัทระงับการใช้ข้อมูลส่วนบุคคลได้ ในกรณีตามที่กฎหมายกำหนด
        </p>
        <p>
          6.6) แจ้งให้บริษัทดำเนินการให้ข้อมูลส่วนบุคคลนั้นถูกต้องเป็นปัจจุบัน
          สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด
        </p>
        <p>
          6.7) ร้องเรียนในกรณีที่ผู้ควบคุมข้อมูลส่วนบุคคลหรือผู้ประมวลผลข้อมูล
          ส่วนบุคคล รวมทั้งลูกจ้างหรือผู้รับจ้างของผู้ควบคุมข้อมูลส่วนบุคคลหรือ
          ผู้ประมวลผลข้อมูลส่วนบุคคล ฝ่าฝืนหรือ ไม่ปฏิบัติตามกฎหมายคุ้มครอง
          ข้อมูลส่วนบุคคล
        </p>
      </div>

      <!-- 7. การเพิกถอนความยินยอม -->
      <div>
        <p class="font-weight-bold">
          7. การเพิกถอนความยินยอม
        </p>
        <p>
          เจ้าของข้อมูลสามารถเพิกถอนความยินยอมที่ได้ให้ไว้กับบริษัทในการเก็บ
          รวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลดังกล่าวข้างต้นเสียเมื่อใดก็ได้
          ด้วยการแจ้งความประสงค์
          ให้บริษัททราบพร้อมทั้งเหตุผลแห่งการนั้น โดยบริษัทจะดำเนินการตามที่
          ได้รับแจ้งเว้นแต่กรณีมีข้อจำกัดสิทธิในการถอนความยินยอมโดยกฎหมาย
          หรือสัญญาที่ให้ประโยชน์แก่เจ้าของข้อมูล
          ทั้งนี้ การเพิกถอนความยินยอมของเจ้าของข้อมูลส่วนบุคคล จะไม่ส่งผล
          กระทบต่อการเก็บรวบรวมใช้ หรือเปิดเผยข้อมูลส่วนบุคคล ที่เจ้าของข้อมูล
          ส่วนบุคคลได้ให้ความยินยอมไปแล้วก่อนหน้านั้น
        </p>
      </div>

      <!-- 8. การปฏิเสธและการจัดทำบันทึก -->
      <div>
        <p class="font-weight-bold">
          8. การปฏิเสธและการจัดทำบันทึก
        </p>
        <p>
          ในกรณีที่เจ้าของข้อมูลร้องขอให้บริษัทดำเนินการตามที่ระบุไว้ในข้อ 6.1-6.7
          หรือ ข้อ 7 บริษัทจะดำเนินการตามที่ได้รับคำร้องขอภายในเวลาที่เหมาะสม
          และตามขั้นตอนการปฏิบัติของบริษัท เว้นแต่ในกรณีดังนี้ บริษัทอาจปฏิเสธ
          การดำเนินการดังกล่าวได้
        </p>
        <p>
          8.1) โดยสภาพแล้วไม่อาจดำเนินการดังกล่าวได้
        </p>
        <p>
          8.2) เป็นการปฏิเสธตามกฎหมายหรือตามคำสั่งศาล และการเข้าถึงและ
          ขอรับสำเนาข้อมูลส่วนบุคคลนั้นจะส่งผลกระทบที่อาจก่อให้เกิดความเสียหาย
          ต่อสิทธิและเสรีภาพบุคคลอื่น
        </p>
        <p>
          8.3) การส่งหรือการโอนข้อมูลส่วนบุคคลนั้นเป็นการปฏิบัติหน้าที่เพื่อประโยชน์
          สาธารณะหรือเป็นการปฏิบัติหน้าที่ตามกฎหมาย หรือการใช้สิทธิดังกล่าวอาจ
          เป็นการละเมิดสิทธิหรือเสรีภาพของบุคคลอื่น
        </p>
        <p>
          8.4) การเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลนั้น ผู้ควบคุมข้อมูล
          ส่วนบุคคลได้แสดงให้เห็นถึงเหตุอันชอบด้วยกฎหมายที่สำคัญยิ่งกว่า
        </p>
        <p>
          8.5) การเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลนั้นเป็นไปเพื่อก่อตั้ง
          สิทธิเรียกร้องตามกฎหมายการปฏิบัติตามหรือการใช้สิทธิเรียกร้องตาม
          กฎหมาย หรือการยกขึ้นต่อสู้สิทธิเรียกร้องตามกฎหมายในกรณีที่บริษัท
          ปฏิเสธไม่ดำเนินการตามคำร้องขอของเจ้าของข้อมูลให้ดำเนินการอย่างใด
          อย่างหนึ่งตามข้อ 6.1-6.8 หรือ ข้อ 7 นั้น บริษัทจะจัดทำรายงานการบันทึก
          การปฏิเสธพร้อมเหตุผลแห่งการปฏิเสธจัดเก็บไว้ในฝ่าย แผนก หรือหน่วยงาน
          อื่นใดภายในบริษัทซึ่งปฏิเสธคำร้องขอของเจ้าของข้อมูล
        </p>
      </div>

      <!-- 9. มาตรการรักษาความมั่นคงปลอดภัยและคุณภาพของข้อมูล -->
      <div>
        <p class="font-weight-bold">
          9. มาตรการรักษาความมั่นคงปลอดภัยและคุณภาพของข้อมูล
        </p>
        <p>
          บริษัทตระหนักถึงความสำคัญของการรักษาความมั่นคงปลอดภัยของข้อมูล
          ส่วนบุคคลของท่าน บริษัทจึงกำหนดให้มีมาตรการในการรักษาความมั่นคง
          ปลอดภัยของข้อมูลส่วนบุคคลอย่างเหมาะสมและสอดคล้องกับการรักษา
          ความลับของข้อมูลส่วนบุคคลเพื่อป้องกันการสูญหาย การเข้าถึง ทำลาย ใช้
          แปลง แก้ไขหรือเปิดเผยข้อมูลส่วนบุคคลโดยไม่มีสิทธิหรือโดยไม่ชอบด้วย
          กฎหมาย ตลอดจนการป้องกันมิให้มีการนำข้อมูลส่วนบุคคลไปใช้โดยมิได้รับ
          อนุญาต นอกจากนี้คณะกรรมการของบริษัทยังได้จัดทำนโยบายระเบียบปฏิบัติ
          คู่มือ แนวทางและอบรมให้ความรู้ ในการเก็บรักษา ใช้ และเปิดเผยข้อมูลส่วน
          บุคคล เพื่อให้พนักงานของบริษัทในทุกระดับชั้นดำเนินการเก็บรักษา ใช้ และ
          ปิดเผยข้อมูลส่วนบุคคลปฏิบัติตามมาตราฐานของบริษัทและสอดคล้องกับ
          กฎหมายที่เกี่ยวข้อง
        </p>
      </div>

      <!-- 10. เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล -->
      <div>
        <p class="font-weight-bold">
          10. เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
        </p>
        <p>
          บริษัทได้มีการดำเนินการปฏิบัติตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
          พ.ศ. 2562 โดยแต่งตั้งเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (Data Protection
          Officer : DPO) เพื่อตรวจสอบการดำเนินการของบริษัทที่เกี่ยวกับการเก็บรวบ
          รวม ใช้และเปิดเผยข้อมูลส่วนบุคคลให้สอดคล้องกับพระราชบัญญัติคุ้มครอง
          ข้อมูลส่วนบุคคล พ.ศ. 2562รวมถึงกฎหมายที่เกี่ยวข้องกับการคุ้มครองข้อมูล
          ส่วนบุคคล นอกจากนี้ บริษัทได้จัดทำระเบียบ คำสั่งให้ผู้เกี่ยวข้องดำเนินการตาม
          ที่กำหนดไว้ เพื่อให้การดำเนินงานตามแนวนโยบายเกี่ยวกับการคุ้มครองข้อมูล
          ส่วนบุคคลให้เป็นไปด้วยความเรียบร้อย อีกทั้ง ยังเป็นไปตามนโยบายของคณะ
          กรรมการกำกับการบริหารข้อมูลส่วนบุคคลและความมั่นคงปลอดภัยไซเบอร์
          ของบริษัทที่กำหนด
        </p>
      </div>

      <!-- 11. ระยะเวลาการเก็บและการทำลายข้อมูลส่วนบุคคล -->
      <div>
        <p class="font-weight-bold">
          11. ระยะเวลาการเก็บและการทำลายข้อมูลส่วนบุคคล
        </p>
        <p>
          บริษัทจะจัดเก็บรักษาข้อมูลตามที่ได้รับจากเจ้าของข้อมูลตามระยะเวลาเท่าที่
          จำเป็นในการดำเนินการตามวัตถุประสงค์ดังที่ได้กล่าวมาข้างต้นเท่านั้น
          เว้นแต่ในกรณีที่มีกฎหมายกำหนดไว้โดยเฉพาะให้เก็บไว้ได้นานกว่านั้น หรือ
          เป็นการจำเป็นเพื่อการก่อตั้งสิทธิเรียกร้องตามกฎหมาย การปฏิบัติตามหรือ
          การใช้สิทธิเรียกร้องตามกฎหมายหรือการยกขึ้นต่อสู้ซึ่งสิทธิเรียกร้องตาม
          กฎหมาย หรือเพื่อดำเนินการตามสัญญาซึ่งบริษัทมีสิทธิตามกฎหมาย
        </p>
      </div>

      <!-- 12. ช่องทางการติดต่อบริษัท -->
      <div>
        <p class="font-weight-bold">
          12. ช่องทางการติดต่อบริษัท
        </p>
        <p>
          บริษัท เซลสุกิ จำกัด
        </p>
        <p>
          10/39 ชั้นที่ 3 ถนนรัชดาภิเษก แขวงจันทรเกษม เขตจตุจักร กรุงเทพมหานคร
          10900 หรือติดต่อผ่าน แผนกคุ้มครองข้อมูลส่วนบุคคล (Data Protection
          Office Unit)
        </p>
        <p>
          Email: lineagency@sellsuki.com
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyPage'
}
</script>

<style lang="scss" scoped>
#privacy-policy-page {
    background-color: #E5E5E5;

    > .background-header {
        height: 200px;
        background-color: #2C395A;

        > .logo {
            z-index: 1;
        }
    }

    > .container {
        background-color: #FFFFFF;
        border-radius: 20px 20px 0px 0px;
        margin-top: -50px;
        padding: 30px;
        padding-top: 90px;

        > div {
            line-height: 24px;
            margin-bottom: 50px;

            > h1 {
                font-size: 36px;
                line-height: 54px;
                margin-bottom: 20px;
            }

             p {
                margin-bottom: 0px;
            }
        }
    }
}

@media only screen and (max-width: 600px) {
    #privacy-policy-page {
        > .background-header {
            > .logo {
                margin-top: 50px;
            }
        }

        > .container {
            margin-top: 40px;
            padding-top: 50px;

            > div {
                > h1 {
                    font-size: 30px;
                    line-height: 45px;
                }
            }
        }
    }
}
</style>
